import React, { ComponentProps, FC, useEffect, useState } from 'react';
import { useCountUp } from 'react-countup';

import Text from 'components/styled/Text';

import useIntersectionObserver from 'hooks/useIntersectionObserver';

type Props = {
	id: string;
	children: number;
} & ComponentProps<typeof Text>;

const Countup: FC<Props> = ({ id, children, ...props }) => {
	const { countUp, update } = useCountUp({
		end: children,
		startOnMount: false,
	});

	const isIntersected = useIntersectionObserver(id);
	const [isVisible, setIsVisible] = useState(false);
	useEffect(() => {
		if (!isIntersected || isVisible || children === 0) {
			return;
		}
		setIsVisible(true);
		setTimeout(() => update(children), 500);
	}, [isIntersected, isVisible, update, children]);

	return (
		<Text id={id} {...props}>
			{countUp}
		</Text>
	);
};
export default Countup;
